/**
 * The nihul surfaces: the /nihul app plus the nihul pages that were given their own
 * public-site address (hofesh limud manage). ONE list serving two consumers that must
 * never drift apart: NihulAccessService's login-return allowlist, and the site header's
 * internal-surface test (no ads, no broadcast-notification prompt over an editor's
 * screen). A new own-address surface added here gets both behaviors at once - the
 * 2026-08 popup-in-the-nihul bug was exactly this list existing in one place and not
 * the other. All values are internal Angular routes of THIS site - never a cms address.
 *
 * A leaf module on purpose (no imports): the eagerly-loaded site header pulls only this
 * file into the main bundle, not the lazy nihul area.
 */
export const NIHUL_SURFACE_PATH_PREFIXES = ['/nihul', '/hofeshlimud/manage'];

/** true when the url (a router url or pathname; query/fragment tolerated) is a nihul surface */
export function isNihulSurfaceUrl(url: string): boolean {
    const path = url.split(/[?#]/)[0].toLowerCase();
    return NIHUL_SURFACE_PATH_PREFIXES.some((prefix) => path === prefix || path.startsWith(`${prefix}/`));
}
